import { shouldMockAPI } from '~/params'

// Requests sent before worker.start() resolves bypass MSW and hit the real
// network — any startup fetch must await this in `?mock` sessions.
export const mockingReady: Promise<unknown> =
  import.meta.env.DEV && shouldMockAPI
    ? import('~/mocks').then(({ configureMockNativeServices, worker }) => {
        configureMockNativeServices()
        return worker.start({ onUnhandledRequest: 'bypass' })
      })
    : Promise.resolve()
